import React from 'react';
import { toastr } from 'react-redux-toastr';
import { ApiService } from 'services';

export const OPEN_CROSS_CLIENT_CLONE_FORM_MODAL = 'OPEN_CROSS_CLIENT_CLONE_FORM_MODAL';
export const CLOSE_CROSS_CLIENT_CLONE_FORM_MODAL = 'CLOSE_CROSS_CLIENT_CLONE_FORM_MODAL';
export const CROSS_CLIENT_CLONE_FORM_REQUEST = 'CROSS_CLIENT_CLONE_FORM_REQUEST';
export const CROSS_CLIENT_CLONE_FORM_SUCCESS = 'CROSS_CLIENT_CLONE_FORM_SUCCESS';
export const CROSS_CLIENT_CLONE_FORM_ERROR = 'CROSS_CLIENT_CLONE_FORM_ERROR';

const ResultToastr = (result) => {
  const { customerId, accountNumbers, newCustomer, newAccount, copySupportingDocs } = result;

  return (<div className="advanced-clone-form-confirm">
    <h1>Success</h1>
    <hr />
    <p>
      Form { copySupportingDocs === true ? '& supporting documents ' : ''}cloned successfully.<br />
      Customer:{'\u00A0'}<b>{ customerId }</b>{'\u00A0'}and Account(s):{'\u00A0'}<b>{ accountNumbers.toString() }</b>{'\u00A0'} { newCustomer || newAccount ? 'created &' : '' } linked.
    </p>

  </div>);
};

function openModal(form) {
  return {
    type: OPEN_CROSS_CLIENT_CLONE_FORM_MODAL,
    crossClientCloneForm: form
  };
}

function closeModal() {
  return {
    type: CLOSE_CROSS_CLIENT_CLONE_FORM_MODAL,
  };
}

function request() {
  return {
    type: CROSS_CLIENT_CLONE_FORM_REQUEST
  };
}

function reject(error) {
  return {
    type: CROSS_CLIENT_CLONE_FORM_ERROR,
    crossClientCloneFormError: error
  };
}

export function crossClientClone(source, destination) {
  const sourceClientId = source.clientId;
  const sourceFormId = source.itemId;
  const targetClientId = destination.client.key;
  const targetCustomerId = destination.customerId;
  const targetAccountIds = destination.accounts?.map(x => x.value);
  const targetLegalEntityIds = destination.legalEntities?.map(x => x.id);
  const { newCustomer, newAccount, copySupportingDocs } = destination;

  return (dispatch) => {
    dispatch(request());
    const promise = () => ApiService
      .crossClientCloneForm(sourceFormId, sourceClientId, targetClientId, targetCustomerId, targetAccountIds, newCustomer, newAccount, targetLegalEntityIds, copySupportingDocs)
      .then((response) => {
        const toastOptions = {
          id: 'clone-confirm',
          disableCancel: true
        };
        if (response.data) {
          dispatch(closeModal());
          const responseData = { ...response.data, copySupportingDocs };
          toastOptions.component = () => (<ResultToastr { ...responseData } />);
        } else {
          dispatch(reject({
            code: 200,
            message: 'There was a problem cloning the form. Please check the status of the uploaded form.'
          }));
          return;
        }
        toastr.confirm(null, toastOptions);
      })
      .catch((error) => {
        if (error.response.data) {
          dispatch(reject(error.response.data));
        } else {
          dispatch(reject({
            code: 503,
            message: 'There was a problem communicating with the server. Please check the status of your uploaded form.'
          }));
        }
      });
    return promise();
  };
}

export function showCrossClientCloneFormModal(form) {
  return dispatch => dispatch(openModal(form));
}

export function hideCrossClientCloneFormModal() {
  return dispatch => dispatch(closeModal());
}
